module.exports = __webpack_public_path__ + "static/media/focus.6e2b8632.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/data/carImages/远程锋锐F3E厢式车/focus.png
// module id = 697
// module chunks = 0